/**
 * Main container
 * imported in App.js
 */
import React, {Component,} from "react";
import  PropTypes from "prop-types";
import {connect} from "react-redux";
import {Route, Routes, Navigate} from "react-router-dom";

import {Notification as NotificationComponent, BarLoader} from "./shared/widgets";
import {PageWrapper} from "./shared/layout";
import SideBar from "./views/Sidebar";
import {toggleSideBar} from "./redux/actions/sideToggleActions";
import {updateUserAuthorities} from "./redux/actions/authActions";
import {AuthenticationService, checkUserLoginState} from "./services/authorization";
import { onLogoutUser} from './services/login/loginService'
import {routes, extraRoutes} from "./routing/routes";
import {routeComponent} from "./routing/route-componentMapping";
import RouteWrapper from "./routing/RouterWrapper";

class AuthenticatedWrapper extends Component {
    constructor(props) {
        super(props);
        this.authService = AuthenticationService.getInstance();
        let isUserLoggedIn = checkUserLoginState();
        this.state = {
            toggleShow: props.toggleValue,
            redirectToLogin: !isUserLoggedIn || isUserLoggedIn == "null",
            role: this.authService.authorities,
            viewPermission: isUserLoggedIn && isUserLoggedIn !== "null" ? this.authService.viewRights : {}
        };
        this.toggleNavigation = this.toggleNavigation.bind(this);
        this.SideBarShow = this.SideBarShow.bind(this);
        this.SideBarDontShow = this.SideBarDontShow.bind(this);
    }

    componentDidMount() {
        let isUserLoggedIn = checkUserLoginState();
        if (isUserLoggedIn && isUserLoggedIn !== "null") {
            this.props.updateUserAuthorities(this.authService.Authorities);
        } else {
            AuthenticationService.destroyInstance();
        }
    }

    componentDidUpdate(prevProps) {
        const {notificationMessage, isTokenExpired } = this.props;
        // Notification logic
        if (notificationMessage !== prevProps.notificationMessage) {
            this._notificationSystem._addNotification(notificationMessage.type, notificationMessage.message);
        }
        // Token expiration logic
        if (isTokenExpired !== prevProps.isTokenExpired) {
            onLogoutUser();
            AuthenticationService.destroyInstance();
        }
    }


    /**
     * Sidebar Navigation
     */
    toggleNavigation() {
        this.props.toggleSideBarState(this.state.toggleShow);
        this.setState({toggleShow:!this.state.toggleShow})
    }

    SideBarShow() {
        this.setState({toggleShow:false})
        this.props.toggleSideBarState(this.state.toggleShow);
    }

    SideBarDontShow() {
        this.setState({toggleShow:true})
        this.props.toggleSideBarState(this.state.toggleShow);
    }

    moveToPanicReport = () => {
        this.props.navigate('/alerts/panic-alerts');
    }


    render() {
        const {redirectToLogin, viewPermission}=this.state;
        const {isTokenExpired, location}=this.props;
        if (redirectToLogin || isTokenExpired) {
            return <Navigate to={extraRoutes.LOGIN} state={{from: location}} /> 
        }

        const firstAccessibleRoute = Object.keys(routes).find(key => viewPermission?.[routes[key]]);
                    
        return <div className={this.state.toggleShow ? 'nav-toggle' : '' }>
            <BarLoader />
            <PageWrapper>
                <SideBar toggleShow={this.state.toggleShow} SideBarShow={this.SideBarShow} SideBarDontShow={this.SideBarDontShow} toggle={this.toggleNavigation} location={location} moveToPanicReport={this.moveToPanicReport} role={this.state.role}/>
                    <Routes>
                        {Object.keys(routes).map((key) => {
                            const routePath = routes[key];
                            const Component = routeComponent[routePath];

                            if (viewPermission?.[routePath]) {
                            return (
                                <Route
                                key={routePath}
                                path={routePath + '/*'}
                                element={<RouteWrapper component={Component} />}
                                />
                            );
                            }

                            return null;
                        })}
                        {firstAccessibleRoute && (
                            <Route path="*" element={<Navigate to={routes[firstAccessibleRoute]} replace />} />
                        )}
                        </Routes>

            </PageWrapper>
            <NotificationComponent ref={el => (this._notificationSystem = el)} />
        </div>
    }
}


AuthenticatedWrapper.propTypes = {
  isTokenExpired: PropTypes.bool,
  location: PropTypes.object,
  notificationMessage: PropTypes.object,
  toggleValue: PropTypes.bool,
  toggleSideBarState: PropTypes.func,
  updateUserAuthorities: PropTypes.func,
  navigate: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        isTokenExpired: state.Auth.isTokenExpired,
        notificationMessage: state.Notification.message,
        toggleValue: state.SideBarToggle.togglerValue
    };
}
const mapDispatchToProps = dispatch => {
    return {
        updateUserAuthorities: value => {
            dispatch(updateUserAuthorities(value))
        },
        toggleSideBarState: (value)=> {
            dispatch(toggleSideBar(value))
        }
    }
};
export  default  connect(mapStateToProps, mapDispatchToProps)(AuthenticatedWrapper);
